import { Component, Inject, Input } from '@angular/core';
import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent {
  constructor(@Inject(EnvironmentToken) private environment: Environment) {}

  @Input() isStudios = false;
  // The logo isn't centering correctly on talent availability page
  // this fixes it, without risking breaking the component elsewhere
  @Input() isTalentAvailabilityPage = false;

  openWebsite(): void {
    top.location.replace(this.environment.aquentWebsite);
  }
}
